// @ts-nocheck
export const CITY_HOME_ROUTES = [
  { path: '/ai-jobs-in-san-francisco', key: 'city-san-francisco', initialLocation: 'San Francisco' },
  { path: '/ai-jobs-in-new-york', key: 'city-new-york', initialLocation: 'New York' },
  { path: '/ai-jobs-in-london', key: 'city-london', initialLocation: 'London' },
  { path: '/ai-jobs-in-toronto', key: 'city-toronto', initialLocation: 'Toronto' },
  { path: '/ai-jobs-in-paris', key: 'city-paris', initialLocation: 'Paris' },
  { path: '/ai-jobs-in-berlin', key: 'city-berlin', initialLocation: 'Berlin' },
  { path: '/ai-jobs-in-seattle', key: 'city-seattle', initialLocation: 'Seattle' },
  { path: '/ai-jobs-in-heidelberg', key: 'city-heidelberg', initialLocation: 'Heidelberg' },
  { path: '/ai-jobs-in-cologne', key: 'city-cologne', initialLocation: 'Cologne' },
  { path: '/ai-jobs-in-munich', key: 'city-munich', initialLocation: 'Munich' },
  { path: '/ai-jobs-in-amsterdam', key: 'city-amsterdam', initialLocation: 'Amsterdam' },
];

export const ROLE_HOME_ROUTES = [
  { path: '/machine-learning-jobs', key: 'role-ml', initialFilter: '_field:ml' },
  { path: '/nlp-jobs', key: 'role-nlp', initialFilter: '_field:nlp' },
  { path: '/llm-jobs', key: 'role-llm', initialFilter: '_field:llm' },
  { path: '/data-science-jobs', key: 'role-ds', initialFilter: '_field:data-science' },
  { path: '/prompt-engineering-jobs', key: 'role-prompt', initialFilter: '_field:prompt-engineering' },
  { path: '/ai-research-jobs', key: 'role-research', initialFilter: '_field:research' },
  { path: '/marketing-jobs', key: 'role-marketing', initialFilter: '_field:marketing' },
  { path: '/product-marketing-jobs', key: 'role-product-marketing', initialFilter: '_field:product-marketing' },
  { path: '/non-tech-jobs', key: 'role-non-tech', initialFilter: '_field:non-tech' },
];

export const SPECIALIZED_HOME_ROUTES = [
  { path: '/top-ai-internships', key: 'top-internships', forcedTag: '_role:internship', topInternships: true },
  { path: '/ai-internships', key: 'internships', forcedTag: '_role:internship' },
  { path: '/entry-developer-jobs', key: 'entry-developer', initialFilter: '_field:developer' },
  { path: '/entry-non-tech-jobs', key: 'entry-non-tech', initialFilter: '_field:non-tech' },
  { path: '/entry-designer-jobs', key: 'entry-designer', initialFilter: '_field:designer' },
  { path: '/ai-marketing-jobs', key: 'ai-marketing', initialFilter: '_field:marketing' },
  { path: '/ai-product-jobs', key: 'ai-product', initialFilter: '_field:product' },
];

export const COMING_SOON_ROUTES = [
  {
    path: '/post-job',
    title: 'Employer Tools Coming Soon',
    description: 'Employer posting and pipeline tools are not open yet. Use the advertising page for current partnership options.',
    ctaLabel: 'View advertising options',
    ctaTo: '/ads'
  },
  {
    path: '/candidatures',
    title: 'Candidacies Hub Coming Soon',
    description: 'Application tracking is not live yet. For now, save jobs and manage alerts from your account.',
    ctaLabel: 'Open account',
    ctaTo: '/account'
  },
  {
    path: '/opportunities',
    title: 'Opportunities Feed Coming Soon',
    description: 'This discovery feed is not live yet. Browse companies, jobs, and events from the main navigation.',
    ctaLabel: 'Browse companies',
    ctaTo: '/companies'
  },
];

export const SALARY_DETAIL_PATHS = [
  '/developer-salaries',
  '/non-tech-salaries',
  '/highest-paying-ai-jobs',
  '/usa-vs-world-salaries'
];
